/* eslint-disable react/destructuring-assignment */
/* eslint-disable consistent-return */
import React, { useCallback } from 'react';
import { FiCheck } from 'react-icons/fi';
import { format, addMinutes } from 'date-fns';
import { Checkbox, CheckedCheckbox } from './styles';

// Ordena a table pra cima ou baixo.
const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = React.useState(config);

  const sortedItems = React.useMemo(() => {
    const sortableItems = [...items];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = key => {
    let direction = 'ascending';
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};

// Retorna a table.
const MultaTable = props => {
  const { items, requestSort, sortConfig } = useSortableData(props.contents);
  const { selectedItems, setSelectedItems } = props;
  const getClassNamesFor = name => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const handleInputSelection = useCallback(
    id => {
      const alreadySelected = selectedItems.findIndex(item => item === id);

      if (alreadySelected >= 0) {
        const filteredItems = selectedItems.filter(item => item !== id);
        setSelectedItems(filteredItems);
      } else {
        setSelectedItems([...selectedItems, id]);
      }
    },
    [selectedItems, setSelectedItems]
  );

  const formatDate = useCallback(dateString => {
    return format(addMinutes(new Date(dateString), 500), 'dd/MM/yyyy');
  }, []);

  return (
    <table>
      <tbody>
        <tr className="table-header">
          <td>
            <p />
          </td>
          <td>
            <button
              type="button"
              onClick={() => requestSort('client_id')}
              className={getClassNamesFor('client_id')}
            >
              Cliente
            </button>
          </td>
          <td>
            <button
              type="button"
              onClick={() => requestSort('due_date')}
              className={getClassNamesFor('due_date')}
            >
              Data de vencimento
            </button>
          </td>
          <td>
            <button
              type="button"
              onClick={() => requestSort('fee_value')}
              className={getClassNamesFor('fee_value')}
            >
              Valor do fee
            </button>
          </td>
          <td>
            <button
              type="button"
              onClick={() => requestSort('royalties_value')}
              className={getClassNamesFor('royalties_value')}
            >
              % Royalties
            </button>
          </td>
          <td>
            <button
              type="button"
              onClick={() => requestSort('matriz_value')}
              className={getClassNamesFor('matriz_value')}
            >
              Valor matriz
            </button>
          </td>
        </tr>

        {items.map(item => {
          return (
            <tr key={item.id}>
              <td>
                {!selectedItems.includes(item.id) ? (
                  <CheckedCheckbox
                    onClick={() => handleInputSelection(item.id)}
                  >
                    <FiCheck size={12} color="var(--white)" />
                  </CheckedCheckbox>
                ) : (
                  <Checkbox onClick={() => handleInputSelection(item.id)} />
                )}
              </td>
              <td>{item.client.name}</td>
              <td>{formatDate(item.due_date)}</td>
              <td>
                {Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(item.fee_value)}
              </td>
              <td>{item.royalties_value}%</td>
              <td>
                {Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(item.matriz_value)}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default MultaTable;
